module.exports = __webpack_public_path__ + "media/images/marker-b0546c918380a43704943b9f997c95ae.png";